<template>
  <div class="loginBox">
    <div class="register">
      <div class="top">
        <span class="top-left">账号注册</span>
        <span class="top-right">已有账号,
          <span @click="$router.push({ path: '/login' })">去登陆 ></span>
        </span>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm">
        <el-form-item label="账号类型" prop="type">
          <el-radio-group v-model="ruleForm.type">
            <el-radio label="1">个人账户</el-radio>
            <el-radio label="100">企业账户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="ruleForm.mobile" placeholder='请输入手机号' :keyup="ruleForm.mobile=ruleForm.mobile.replace(/[^\d]/g,'')" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="captcha">
          <el-input v-model="ruleForm.captcha" placeholder="请输入验证码" :keyup="ruleForm.captcha=ruleForm.captcha.replace(/[^\d]/g,'')" maxlength="4"></el-input>
          <el-button type="text" size="small" :disabled="timer > 0" @click="handleCode" class="button">
            {{ timer == 0 ? "获取验证码" : timer + "秒后重试" }}
          </el-button>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input v-model="ruleForm.password" type='password' placeholder="请输入最少六位包含数字字母的密码"></el-input>
        </el-form-item>
        <el-form-item label="邀请码">
          <el-input v-model="ruleForm.inviteCode" placeholder='请输入邀请码(选填)'></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit('ruleForm')">立即注册</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var checkPhone = (rule, value, callback) => {
      const reg = /^1[3|4|5|7|8][0-9]{9}$/;
      if (!value) {
        callback(new Error("请输入手机号码"));
      } else {
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("请正确输入手机号码"));
        }
      }
    };
    var checkPassword = (rule, value, callback) => {
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,8}$/
      if (!value) {
        callback(new Error("请输入新密码最少六位并且不能纯数字"));
      } else {
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入新密码最少六位并且不能纯数字"));
        }
      }
    }
    return {
      ruleForm: {
        type: '1',
        mobile: '',
        captcha: '',
        password: '',
        inviteCode: '',
        passCard: {
          From_Device: "pc",
          From_ID: "",
          From_IP: "",
          From_MAC: "",
          From_OS: "web",
          Hash_Subject: "",
          Invite_code: "",
          Timestamp: new Date().getTime(),
        },
      },
      rules: {
        mobile: [
          { required: true, validator: checkPhone, trigger: 'blur' },
        ],
        captcha: [
          { required: true, message: '请输入手机验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '长度为4个字符', trigger: 'blur' }
        ],
        password: [
          { required: true,  validator: checkPassword, trigger: "blur" },
        ],
      },
      timer: 0,
      tick: null

    };
  },
  methods: {
    //发送手机验证码
    handleCode() {
      if (!/^1[3456789]\d{9}$/.test(this.ruleForm.mobile)) {
        this.$message({
          type: "error",
          message: "请正确输入手机号码!",
          duration: 1000,
        });

        return false;
      }
      this.handleStart();
      this.$axiosGet(this.$store.state.login_url + "shortMessage/getMobileVerificationCode", {
        mobile: this.ruleForm.mobile,
      }).then(res => {
        if (res.code == 200) {
          this.$message({
            message: '验证码发送成功',
            type: 'success'
          });
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //验证码倒计时
    handleStart() {
      this.handleClose();
      this.timer = 30;
      this.tick = setInterval(() => {
        if (this.timer > 0) {
          this.timer--
        }
      }, 1000)
    },
    handleClose() {
      if (this.tick) {
        clearInterval(this.tick)
      }
    },
    //注册-提交
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let fd = new FormData();
          this.ruleForm.passCard.From_ID = this.ruleForm.mobile;

          fd.append("mobile", this.ruleForm.mobile);
          fd.append("password", this.$md5(this.ruleForm.password));
          fd.append("captcha", this.ruleForm.captcha);
          fd.append("passCard", JSON.stringify(this.ruleForm.passCard));
          fd.append("channel", "时空社_官网");
          fd.append("flag", "1");

          fd.append("inviteCode", this.ruleForm.inviteCode);
          fd.append("type", this.ruleForm.type);
          const loading = this.loading();
          this.$axios.post(this.$store.state.login_url + "/user/v2/register",
            fd
          ).then(res => {
            loading.close();
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "注册成功!",
              });
              this.$router.push({ path: '/login' })
            } else {
              this.$message.error(res.data.message);
            }
          })
        }
      })
    },

  }
}
</script>

<style scoped lang="scss">
.loginBox {
  background: #f6f7f9;
  padding: 20px 0;
  // height: 688px;
  .register {
    width: 1200px;
    height: 782px;
    margin: 0 auto;
    background: #ffffff;
    .top {
      display: flex;
      justify-content: space-between;
      height: 66px;
      line-height: 66px;
      border-bottom: 1px solid #f2f2f2;
      margin: 0 31px;
      .top-left {
        font-size: 16px;
        color: #282828;
        font-weight: 600;
        font-weight: bold;
      }
      .top-right {
        font-size: 16px;
        font-weight: 600;
        font-weight: bold;
        span {
          color: #1E8AE4;
          cursor: pointer;
        }
      }
    }
    .ruleForm {
      width: 606px;
      display: block;
      margin: 0 auto;
      margin-top: 37px;
      ::v-deep.el-form-item__label {
        color: #666;
      }
      ::v-deep.el-radio {
        color: #999999;
        font-size: 14px;
      }
      // ::v-deep.el-radio__input.is-checked .el-radio__inner {
      //   border-color: #1C77FF;
      //   background: #1C77FF;
      // }
      ::v-deep.el-radio__input.is-checked + .el-radio__label {
        color: #282828;
        font-weight: bold;
        font-weight: 600;
      }
    }
  }
}

.el-input {
  width: 100%;
}
.el-button {
  width: 100%;
}
// .el-button--primary {
//   background-color: #1C77FF;
//   border-color: #1C77FF;
// }
.el-form-item {
  margin-bottom: 30px;
  width: 100%;
  position: relative;
  .button {
    width: 86px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    position: absolute;
    right: 0;
    top: 2px;
    padding: 0;
    // color: #1C77FF;
  }
}
</style>>